// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionMonitoringRequiredDto
 */
export interface IContributionMonitoringRequiredDto {
    /**
     * 
     * @type {boolean}
     * @memberof IContributionMonitoringRequiredDto
     */
    contribution_monitoring_required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IContributionMonitoringRequiredDto
     */
    contribution_monitoring_required_state?: IContributionMonitoringRequiredDtoContributionMonitoringRequiredStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IContributionMonitoringRequiredDtoContributionMonitoringRequiredStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IContributionMonitoringRequiredDto interface.
 */
export function instanceOfIContributionMonitoringRequiredDto(value: object): value is IContributionMonitoringRequiredDto {
    return true;
}

export function IContributionMonitoringRequiredDtoFromJSON(json: any): IContributionMonitoringRequiredDto {
    return IContributionMonitoringRequiredDtoFromJSONTyped(json, false);
}

export function IContributionMonitoringRequiredDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionMonitoringRequiredDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_monitoring_required': json['contribution_monitoring_required'] == null ? undefined : json['contribution_monitoring_required'],
        'contribution_monitoring_required_state': json['contribution_monitoring_required_state'] == null ? undefined : json['contribution_monitoring_required_state'],
    };
}

export function IContributionMonitoringRequiredDtoToJSON(json: any): IContributionMonitoringRequiredDto {
    return IContributionMonitoringRequiredDtoToJSONTyped(json, false);
}

export function IContributionMonitoringRequiredDtoToJSONTyped(value?: IContributionMonitoringRequiredDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_monitoring_required': value['contribution_monitoring_required'],
        'contribution_monitoring_required_state': value['contribution_monitoring_required_state'],
    };
}

